import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";

export default React.memo(function Rain({
  count = 80000,
  area = 400,
  height = 300,
}) {
  const mesh = useRef();
  const positions = useMemo(() => {
    const arr = new Float32Array(count * 3);
    for (let i = 0; i < count; i++) {
      const idx = i * 3;
      arr[idx] = Math.random() * area - area / 2;
      arr[idx + 1] = Math.random() * height;
      arr[idx + 2] = Math.random() * area - area / 2;
    }
    return arr;
  }, [count, area, height]);
  useFrame((_, delta) => {
    const arr = mesh.current.geometry.attributes.position.array;
    const dx = delta * 2;
    const dy = delta * 18;
    for (let i = 0; i < count; i++) {
      const idx = i * 3;
      arr[idx] += dx; // viento lateral
      arr[idx + 1] -= dy; // gotas más finitas y rápidas
      if (arr[idx + 1] < 0) {
        arr[idx] = Math.random() * area - area / 2;
        arr[idx + 1] = height;
        arr[idx + 2] = Math.random() * area - area / 2;
      }
    }
    mesh.current.geometry.attributes.position.needsUpdate = true;
  });
  return (
    <points ref={mesh}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          count={count}
          array={positions}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial color="#aee6f9" size={0.04} sizeAttenuation />
    </points>
  );
});
